import Mock from 'mockjs' // 引入mockjs

const date_list = []
const exhibition_name_list = []
const selectVisitResult = []
const num = 4
// const submitReturnData = []

function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
      return {}
    }
    return JSON.parse(
      '{"' +
        decodeURIComponent(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    )
  }

date_list.push(Mock.mock(
    {
        'id':1,
        'time_slice':'上午(8：00至11：30)',
        'reserved_people':'2',
        'max_people': '30'
    }
))
date_list.push(Mock.mock(
    {
        'id':2,
        'time_slice':'下午(2：00至5：30)',
        'reserved_people':'0',
        'max_people': '30'
    }
))

for (let i = 0; i < num; i++) {
    // mock参观选择展厅
    exhibition_name_list.push(Mock.mock(
    {
      'id|1-10000': 1,                                          // id每次循坏自增1
      'exhibition_name|1': ['南粤丰碑', '永远情怀', '心迹墨痕', '快乐不止'],  // 每次随机取其中一个
      'exhibition_depict|1':
      [
          '九十三年的风雨洗礼，三万三千多天的昼夜兼程。档案,默默地记录与见证了广东党组织所经历的一切。从国共合作到土地革命,从抗日战争到解放战争,从新中国建立到改革开放,广东党组织始终顺应时代的潮流,代表南粤几千万儿女发出了时代的强音。当我们再次驻足,凝视曾经的腥风血雨、炮火硝烟,聆听过往的发聩呐喊、时代强音,我们由衷地为这些定格的勇敢与坚定感到骄傲,为这些携铸的悲壮与激情感到自豪。我们更有理由相信,南粤大地,这片始终经历着最多自然风雨的洗礼,不断承载着历史大任的神奇土地,在广东省委的坚强带领下,一定会不负众望,高擎中国特色社会主义的伟大旗帜,继续立定时代的潮头,收获科学发展的丰硕成果。',
          '三万三千多天的昼夜兼程。档案,默默地记录与见证了广东党组织所经历的一切。从国共合作到土地革命,从抗日战争到解放战争,从新中国建立到改革开放,广东党组织始终顺应时代的潮流,代表南粤几千万儿女发出了时代的强音。当我们再次驻足,凝视曾经的腥风血雨、炮火硝烟,聆听过往的发聩呐喊、时代强音,我们由衷地为这些定格的勇敢与坚定感到骄傲,为这些携铸的悲壮与激情感到自豪。'
      ],
      'date_time':''
    }
  ))
}

selectVisitResult.push(Mock.mock(
    {
        'unit_name|1': ['黄埔区玉泉中学', '天河区居委会', '执信中学', '广雅中学'],
        'date_time':'2021-01-04',
        'contact_name|1': ['back', 'princelingg'],
        'visit_quantity|1-30':30,
        'contact_tel':'13828281919',
        'id':'20210104231'
    }
))

selectVisitResult.push(Mock.mock(
    {
        'unit_name|1': ['黄埔区玉泉中学', '天河区居委会', '执信中学', '广雅中学'],
        'date_time':'2021-01-04',
        'contact_name|1': ['back', 'princelingg'],
        'visit_quantity|1-30':30,
        'contact_tel':'13828281919',
        'id':'20210104232'
    }
))

export default {
// 获取参观确认时间
getVisitTime: config =>{
    console.log(config)
    const { date_time } = param2Obj(config.url)
    if(date_time==''||date_time==null) {
        return {
            code: "204",
            data: [],
            msg: 'not find time!'
        }
    }
    return {
        code: "00",
        data: date_list
    }
},
// 获取参观展厅
getExhibtionRoom: config =>{
    const { date_time } = param2Obj(config.url)
    if(date_time==''||date_time==null) {
        return {
            code: "204",
            data: [],
            msg: 'not find time!'
        }
    }
    return {
        code: "00",
        data: exhibition_name_list
    }
},
// 提交参观预约信息
submitVisitReserve: config => ({
    code: "00",
    data: [JSON.parse(config.body)]
}),
// 参观预约查询
selectVisit: config =>{
    const { id_card } = param2Obj(config.url)
    if(id_card==''||id_card==null) {
        return {
            code: "204",
            data: [],
            msg: 'not find id_card!'
        }
    }
    return {
        code: "00",
        data: {"date_list":selectVisitResult}
    }
},
// 参观预约取消
delVisit: config =>{
    const { id } = param2Obj(config.url)
    if(id==''||id==null) {
        return {
            code: "204",
            data: [],
            msg: 'not find id!'
        }
    }
    return {
        code: "99",
        data: '成功取消预约！'
    }
},
  // look
//   getOrgList: () => {
//     return {
//       total: List.length,
//       data: List
//     }
//   },
//   // add
//   createOrg: () => ({
//     resultCode: 200,
//     data: 'success'
//   }),
//   // edit
//   updateOrg: () => ({
//     resultCode: 200,
//     data: 'success'
//   }),
//   // delete
//   orgDelete: () => ({
//     resultCode: 200,
//     data: 'success'
//   }),
//   getTaskCategory:() => {
//     return {
//       total: 2,
//       data: 'test'
//     }
//   }
}